<div class="grid w-full max-w-lg items-center">
  <select
    class="select col-start-1 row-start-1 w-full pr-10"
    [(ngModel)]="value"
    [ngClass]="forwardedClasses"
    [disabled]="disabled"
    [required]="required()"
    (change)="handleChange($event)"
    (blur)="handleTouched()"
  >
    @for (option of options(); track option.value) {
      <option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </option>
    }
  </select>
  <div
    class="pointer-events-none col-start-1 row-start-1 mr-4 flex h-4 w-4 justify-self-end"
  >
    <img class="h-4 w-4" src="/assets/icons/arrow_down.svg" alt="Arrow Down" />
  </div>
</div>
